export const STATUSSES = {
  new: 'Nieuw',
  approved: 'Goedgekeurd',
  disapproved: 'Afgekeurd',
};

export const ACTIVITY_STATUSSES = {
  approved: 'GOEDGEKEURD',
  disapproved: 'AFGEKEURD',
};

export const ACTIVITY_TYPES = {
  INTERVISIE: 'Intervisie',
  PSBK_BIJSCHOLING: 'PSBK activiteit',
  ANDERE_PSBK_BIJSCHOLING: 'Andere PSBK-bijscholing',
  KORTDURENDE_CURSUS_GEACCREDITEERD: 'Geaccrediteerde scholing',
  KORTDURENDE_CURSUS_NIET_GEACCREDITEERD: 'Niet-geaccrediteerde scholing',
  SUPERVISIE: 'Supervisie',
  MENTORING: 'Mentoring',
  OPLEIDING: 'Schrijfactiviteit',
  NVPA_VAKGROEPBIJEENKOMST: 'PSBK - Vakgroepbijeenkomst',
  NVPA_STUDIEDAG: 'PSBK - Studiedag',
  ALV: 'Algemene Ledenvergadering',
};

export const PAYMENT_TYPES = {
  IDEAL: 'iDeal',
  LATER: 'Later',
  GRATIS: 'Gratis',
  WERKGROEPLID_COORDINATOR: 'Werkgroeplid_coordinator',
};
